import React, {useState} from 'react';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded';
import MedicationLiquidRoundedIcon from '@mui/icons-material/MedicationLiquidRounded';

function Body() {
    
    const [isHovered, setIsHovered] = useState(false);
    return (      
        <div className="body container"
            style={{ 
                display: "flex", 
                flexDirection: "column",
                alignItems: "stretch",
                paddingTop: "15px", 
                backgroundColor: "#fff", 
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", 
                // marginTop: "95px",
                marginBottom: "70px", 
                maxWidth: "800px",
            }}
        >
            {/* Buscador */}
            <div className="search-bar"
                style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    width: "100%",
                    marginBottom: "20px",
                    borderRadius: "5px"
                }}
            >
                <input 
                    type="text" 
                    placeholder="Escribe un término médico..." 
                    style={{ 
                        flex: 1, 
                        marginRight: "10px", 
                        padding: "11px", 
                        borderRadius: "25px", 
                        border: "2px solid #ccc"
                    }}
                />
                <button 
                    style={{ 
                        padding: "6px 10px", 
                        borderRadius: "25px", 
                        backgroundColor: "#007bff", 
                        color: "#fff", 
                        border: "none" 
                    }}
                >
                    Buscar
                </button>
            </div>

            {/* Niveles */}
            <div
                className="levels-container"
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    marginBottom: "20px",
                }}
            >
                <div
                    className="level-option"
                    style={{
                        flex: 1,
                        padding: "11px",
                        backgroundColor: "#ddd",
                        textAlign: "center",
                        borderStartStartRadius: "5px",
                        borderEndStartRadius: "5px",
                        margin: "0",
                    }}
                >
                    Básico
                </div>
                <div
                    className="level-option active"
                    style={{
                        flex: 1,
                        padding: "11px",
                        backgroundColor: " #007bff",
                        color: "#fff",
                        textAlign: "center",
                        margin: "0",
                    }}
                >
                    Intermedio
                </div>
                <div
                    className="level-option"
                    style={{
                        flex: 1,
                        padding: "11px",
                        backgroundColor: " #ddd",
                        textAlign: "center",
                        borderStartEndRadius: "5px",
                        borderEndEndRadius: "5px",
                        margin: "0",
                    }}
                >
                    Avanzado
                </div>
            </div>
            
            {/*Síntomas relacionados*/}
            <h5 className='text-primary fw-bold'>Síntomas relacionados</h5>
            <div className="symptom-button"
                style={{ 
                    marginTop: "10px",
                    marginBottom: "35px",
                }}>
                
                <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{ 
                    padding: "6px 10px", 
                    borderRadius: "25px", 
                    backgroundColor: "rgb(199, 224, 250)",
                    color: "#007bff", 
                    border: "2px solid rgb(145, 197, 252)",
                    background: isHovered ? "#007bff" : "rgb(199, 224, 250)",
                    borderColor: isHovered ? "#fff" : "rgb(145, 197, 252)",
                    color: isHovered ? "#fff" : "#007bff",
                }}
                >Dolor de cabeza</button>
                <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{ 
                    marginLeft: "10px",
                    padding: "6px 10px", 
                    borderRadius: "25px", 
                    backgroundColor: "rgb(199, 224, 250)",
                    color: "#007bff", 
                    border: "2px solid rgb(145, 197, 252)",
                    background: isHovered ? "#007bff" : "rgb(199, 224, 250)",
                    borderColor: isHovered ? "#fff" : "rgb(145, 197, 252)",
                    color: isHovered ? "#fff" : "#007bff",
                }}
                >Mareos</button>
                <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{ 
                    marginLeft: "10px",
                    padding: "6px 10px", 
                    borderRadius: "25px", 
                    backgroundColor: "rgb(199, 224, 250)",
                    color: "#007bff", 
                    border: "2px solid rgb(145, 197, 252)",
                    background: isHovered ? " #007bff" : "rgb(199, 224, 250)",
                    borderColor: isHovered ? " #fff" : "rgb(145, 197, 252)",
                    color: isHovered ? "#fff" : "#007bff",
                }}
                >Visión borrosa</button>
                <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{ 
                    marginLeft: "10px",
                    padding: "6px 10px", 
                    borderRadius: "25px", 
                    backgroundColor: "rgb(199, 224, 250)",
                    color: " #007bff", 
                    border: "2px solid rgb(145, 197, 252)",
                    background: isHovered ? " #007bff" : "rgb(199, 224, 250)",
                    borderColor: isHovered ? " #fff" : "rgb(145, 197, 252)",
                    color: isHovered ? "#fff" : " #007bff",
                    
                }}
                >Fatiga</button>
            </div>
            
            {/*Síntoma*/}
            <div 
            style={{
                border: "1px solid rgb(255, 255, 255)",
                borderRadius: "15px",
                backgroundColor: " #f8f9fa",
                borderLeftColor: " #007bff",
                borderLeftWidth: "5px",
                marginBottom: "30px",
                

            }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <h3 className='text-dark'
                    style={{
                        marginLeft: "20px",
                        padding: "10px",
                        fontSize: "20px",
                        fontWeight: "bold",
                    }}>Síntoma</h3>
                    <span className='bg-primary fw-bold'
                    style={{
                        backgroundColor: "rgb(23, 164, 5)",
                        borderRadius: "4px",
                        padding: "3px 8px",
                        fontSize: "0.7rem",
                        marginBottom: "5px",
                        color: "white",
                    }}
                    >SNOMED: 38341003</span>
                </div>
                
                {/*Explicación simplificada*/}
                <div
                style={{
                    marginLeft: "20px",
                    marginRight: "20px",
                    marginBottom: "20px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingLeft: "10px",
                    border: "0.5px solid rgb(23, 164, 5)",
                    borderRadius: "15px",
                    backgroundColor: "rgba(192, 250, 184, 0.53)",
                    borderLeftWidth: "5px",
                    borderTopWidth: "0px",
                    borderBottomWidth: "0px",
                    borderRightWidth: "0px",
                    

                }}
                >   
                    
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <CheckCircleRoundedIcon className="text-success" style={{ fontSize: '1.3rem', marginBottom: "5px"}} />
                        <h4
                        style={{
                            marginLeft: "5px",
                            fontSize: "20px",
                            fontWeight: "bold",
                        }}
                        >Explicación simplificada:</h4>
                    </div>
                    
                    <p
                    style={{
                        margin: "1px",
                        marginBottom: "10px",
                    }}
                    >Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos, 
                        ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos.
                        Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos, 
                        ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos. 
                        
                    </p>
                </div>
                
                {/*Definición técnica*/}
                <div
                style={{
                    marginLeft: "20px",
                    marginRight: "20px",
                    marginBottom: "20px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingLeft: "10px",
                    border: "0.5px solid #007bff",
                    borderRadius: "15px",
                    backgroundColor: "rgba(93, 161, 250, 0.3)",
                    borderLeftWidth: "5px",
                    borderTopWidth: "0px",
                    borderBottomWidth: "0px",
                    borderRightWidth: "0px",
                    

                }}
                >   
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <EditNoteRoundedIcon className="text-primary" style={{ fontSize: '2rem', marginBottom: "5px"}} />
                        <h4
                        style={{
                            marginLeft: "5px",
                            fontSize: "20px",
                            fontWeight: "bold",
                        }}
                        >Definición técnica:</h4>
                    </div>
                    
                    <p
                    style={{
                        margin: "1px",
                        marginBottom: "10px",
                    }}
                    >Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos, 
                        ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos.
                        Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos, 
                        ipsum dolor sit amet consectetur adipiscing elit pellentesque inceptos himenaeos. 
                        
                    </p>
                </div>

                    {/*Representación gráfica*/}
                    <div
                    style={{ 
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}>
                        <img src="example.jpg" alt="Representación gráfica" />
                        <p>Lorem ipsum dolor sit amet</p>
                    </div>
                
                
                {/*Terminos relacionados*/}
                <div style={{ 
                    marginLeft: "20px",
                }}>
                    <h5 className='fw-bold'
                    style={{
                        fontSize: "1rem",
                    }}
                    >Terminos relacionados:</h5>

                    <button
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={{ 
                            marginTop: "20px",
                            marginLeft: "0px",
                            padding: "6px 10px", 
                            borderRadius: "25px", 
                            backgroundColor: "rgb(199, 224, 250)",
                            color: "#007bff", 
                            border: "2px solid rgb(145, 197, 252)",
                            background: isHovered ? "#007bff" : "rgb(199, 224, 250)",
                            borderColor: isHovered ? "#fff" : "rgb(145, 197, 252)",
                            color: isHovered ? "#fff" : "#007bff",
                        }}
                    >Hipertensión esencial</button>

                    <button
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={{ 
                            marginTop: "20px",
                            marginLeft: "10px",
                            padding: "6px 10px", 
                            borderRadius: "25px", 
                            backgroundColor: "rgb(199, 224, 250)",
                            color: "#007bff", 
                            border: "2px solid rgb(145, 197, 252)",
                            background: isHovered ? "#007bff" : "rgb(199, 224, 250)",
                            borderColor: isHovered ? "#fff" : "rgb(145, 197, 252)",
                            color: isHovered ? "#fff" : "#007bff",
                        }}
                    >Presión arterial</button>
                    <button
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={{ 
                            marginTop: "20px",
                            marginLeft: "10px",
                            padding: "6px 10px", 
                            borderRadius: "25px", 
                            backgroundColor: "rgb(199, 224, 250)",
                            color: "#007bff", 
                            border: "2px solid rgb(145, 197, 252)",
                            background: isHovered ? "#007bff" : "rgb(199, 224, 250)",
                            borderColor: isHovered ? "#fff" : "rgb(145, 197, 252)",
                            color: isHovered ? "#fff" : "#007bff",
                        }}
                    >Enfermedad cardiovascular</button>
                </div>
                
                {/* Especialistas relacionados */}
                <div
                style={{
                    marginTop: "20px",
                    marginLeft: "20px",
                
                }}
                >
                    <h5 className='fw-bold'
                        style={{
                            fontSize: "1rem",
                        }}
                        
                        >Especialistas relacionados:</h5>

                    {/* Iconos de especialidades relacionados*/}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "35px",
                    }}>                    
                        <div style={{
                            display: "flex", 
                            flexDirection: "column",
                            alignItems: "center",
                            marginTop: "10px",
                        }}>
                            
                            <MonitorHeartRoundedIcon className="text-primary" 
                            style={{ 
                                fontSize: '1.5 rem',
                                marginTop: "10px",
                                marginBottom: "5px",
                                padding: "10px",
                                backgroundColor: "rgb(196, 220, 252)",
                                borderRadius: "50%",
                                width: "60px",
                                height: "60px",
                                }} />
                            
                            <p>Cardiología</p>
                        </div>

                        <div style={{
                            display: "flex",
                            flexDirection: "column ",
                            alignItems: "center",
                            marginTop: "10px",
                        }}>
                            
                            <MedicationLiquidRoundedIcon className="text-primary" 
                            style={{ 
                                fontSize: '1.5 rem',
                                marginTop: "10px",
                                marginBottom: "5px",
                                padding: "10px",
                                backgroundColor: "rgb(196, 220, 252)",
                                borderRadius: "50%",
                                width: "60px",
                                height: "60px",
                                }} />
                            
                            <p>Medicina</p>
                        </div>

                        <div style={{
                            display: "flex",
                            flexDirection: "column ",
                            alignItems: "center",
                            marginTop: "10px",
                        }}>
                            
                            <div className="text-primary" 
                            style={{ 
                                fontSize: '1.5 rem',
                                marginTop: "10px",
                                marginBottom: "5px",
                                padding: "10px",
                                backgroundColor: "rgb(196, 220, 252)",
                                borderRadius: "50%",
                                width: "60px",
                                height: "60px",
                                }} />
                            
                            <p>Cardiología</p>
                        </div>
                    
                    </div>


                </div>

            </div>
            

        </div>        
    );
}

export default Body;